import sameiportime from "./sameiportime.js";
import canvaHeader from "./canvaHeader.js";
import currencyconfig from "./currencyconfig.js";
import currenymask from "./currenymask.js";
import operationconfig from "./operationconfig.js";
import rechargecurrencydailog from "./rechargecurrencydailog.js";
import hovevedge from "./hovevedge.js";
import hovernode from "./hovernode.js";
import leftbottommenu from "./leftbottommenu.js";
import userGuidanceCanvas from "./userGuidanceCanvas.js";
import userOperation from "./userOperation.js";

export default {
  sameiportime,
  canvaHeader,
  currencyconfig,
  currenymask,
  operationconfig,
  rechargecurrencydailog,
  hovevedge,
  hovernode,
  leftbottommenu,
  userGuidanceCanvas,
  userOperation,
};
